import React, { useState, useEffect, useRef } from "react";

const DatesAndSlotsPicker = ({ selectedDate: propDate, selectedSlot: propSlot, onDateChange, onSlotChange }) => {
  const getTodayStr = () => {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const todayStr = getTodayStr();
  const dateInputRef = useRef(null);

  const [selectedDate, setSelectedDate] = useState(propDate || todayStr);
  const [selectedSlot, setSelectedSlot] = useState(propSlot || "");

  // Sync internal state and notify parent when propDate or propSlot changes or on initial mount
  useEffect(() => {
    const activeDate = propDate || todayStr;
    setSelectedDate(activeDate);
    onDateChange?.(activeDate);
  }, [propDate]);

  useEffect(() => {
    if (propSlot) {
      setSelectedSlot(propSlot);
      onSlotChange?.(propSlot);
    }
  }, [propSlot]);

  const handleDateChange = (e) => {
    const date = e.target.value;
    setSelectedDate(date);
    onDateChange?.(date);
  };

  const handleTodayClick = (e) => {
    e.stopPropagation();
    const today = getTodayStr();
    setSelectedDate(today);
    onDateChange?.(today);
  };

  const handleSlotChange = (e) => {
    const slot = e.target.value;
    setSelectedSlot(slot);
    onSlotChange?.(slot);
  };

  const handleWrapperClick = () => {
    if (dateInputRef.current && typeof dateInputRef.current.showPicker === 'function') {
      try {
        dateInputRef.current.showPicker();
      } catch (err) {
        dateInputRef.current.focus();
      }
    }
  };

  return (
    <div className="appointment-date-slot">
      {/* --- Date Picker --- */}
      <div className="form-group">
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '6px' }}>
          <label style={{ margin: 0 }}>Appointment Date</label>
          <button
            type="button"
            className="today-quick-btn"
            onClick={handleTodayClick}
            style={{
              background: '#e0f2fe',
              color: '#0284c7',
              border: '1px solid #bae6fd',
              padding: '3px 10px',
              borderRadius: '6px',
              fontSize: '11.5px',
              fontWeight: '600',
              cursor: 'pointer',
              transition: 'all 0.15s ease'
            }}
          >
            📅 Today
          </button>
        </div>
        <div
          className="calendar-input-wrapper"
          onClick={handleWrapperClick}
        >
          <input
            ref={dateInputRef}
            type="date"
            className="date-picker"
            value={selectedDate}
            onChange={handleDateChange}
          />
        </div>
      </div>

      {/* --- Slot Picker --- */}
      <div className="form-group">
        <label>Select Time Slot</label>
        <select
          className="select-slot-dropdown"
          value={selectedSlot}
          onChange={handleSlotChange}
        >
          <option value="" disabled>
            Select Slot
          </option>
          {Array.from({ length: 24 * 6 }, (_, i) => {
            const hours = Math.floor(i / 6);
            const minutes = (i % 6) * 10;
            const ampm = hours >= 12 ? "PM" : "AM";
            const hour12 = hours % 12 === 0 ? 12 : hours % 12;
            const timeLabel = `${hour12
              .toString()
              .padStart(2, "0")}:${minutes
              .toString()
              .padStart(2, "0")} ${ampm}`;
            const timeValue = `${hours.toString().padStart(2, "0")}:${minutes
              .toString()
              .padStart(2, "0")}:00`;
            return (
              <option key={timeValue} value={timeValue}>
                {timeLabel}
              </option>
            );
          })}
        </select>
      </div>
    </div>
  );
};

export default DatesAndSlotsPicker;
